import { PageHero } from "@/components/PageHero"
import { Reveal } from "@/components/Reveal"
import { RemoteImage } from "@/components/RemoteImage"
import { SectionHeading } from "@/components/SectionHeading"
import { Badge } from "@/components/ui/badge"
import { Card } from "@/components/ui/card"
import { milestones } from "@/data/site"

export default function Development() {
  const visualMilestones = milestones.filter((item) => item.image)

  return (
    <>
      <PageHero eyebrow="Development roadmap" title="From research concept to globally deployable climate infrastructure." description="The development page now includes the supplied historical visuals — from initial design and PhD research through patenting, Good Design, WIPO and live project implementation." />

      <section className="px-6 py-24 sm:py-32">
        <div className="mx-auto max-w-7xl">
          <Reveal><SectionHeading eyebrow="Timeline" title="The Smart Drain development story." description="A clearer narrative has been built using the supplied development images and milestone content." /></Reveal>
          <div className="relative mt-16 before:absolute before:bottom-0 before:left-[18px] before:top-0 before:w-px before:bg-slate-200 dark:before:bg-white/10 md:before:left-1/2">
            {milestones.map((milestone, i) => (
              <Reveal key={`${milestone.year}-${milestone.title}`} delay={Math.min(i * .025, .18)}>
                <div className={`relative mb-10 grid gap-8 md:grid-cols-2 ${i % 2 ? "" : "md:text-right"}`}>
                  <span className="absolute left-[10px] top-2 z-10 size-4 rounded-full border-4 border-[#f7faf9] bg-emerald-400 dark:border-[#0a1214] md:left-1/2 md:-translate-x-1/2" />
                  <div className={i % 2 ? "md:col-start-2 md:pl-12" : "md:pr-12"}>
                    <Badge className="text-emerald-800 dark:text-emerald-300">{milestone.year}</Badge>
                    <h3 className="mt-4 text-2xl font-semibold tracking-[-.04em]">{milestone.title}</h3>
                    <p className="mt-3 leading-7 text-slate-600 dark:text-slate-400">{milestone.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-slate-100 px-6 py-24 sm:py-32 dark:bg-white/[.03]">
        <div className="mx-auto max-w-7xl">
          <Reveal><SectionHeading eyebrow="Milestone visuals" title="Key moments captured along the journey." description="Selected supplied images are now integrated to support the development narrative visually." /></Reveal>
          <div className="mt-12 grid gap-5 md:grid-cols-2 xl:grid-cols-3">
            {visualMilestones.map((item, index) => (
              <Reveal key={`${item.year}-${item.title}-visual`} delay={index * .04}>
                <Card className="group h-full overflow-hidden">
                  {item.image && <RemoteImage src={item.image} alt={item.title} className="aspect-[4/3] transition duration-500 group-hover:scale-[1.02]" />}
                  <div className="p-6">
                    <Badge className="text-emerald-800 dark:text-emerald-300">{item.year}</Badge>
                    <h3 className="mt-4 text-xl font-semibold tracking-[-.03em]">{item.title}</h3>
                    <p className="mt-3 text-sm leading-6 text-slate-600 dark:text-slate-400">{item.body}</p>
                  </div>
                </Card>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
